/**
 * Tiny bootstrap helpers used before LanguageProvider mounts (root redirect).
 */

import { DEFAULT_LOCALE } from './localePaths';

export { DEFAULT_LOCALE };

/**
 * @returns {'es'|'en'}
 */
export const readStoredLocale = () => {
  try {
    const stored = localStorage.getItem('clarcv_lang');
    if (stored === 'es' || stored === 'en') return stored;
  } catch (_) {
    /* ignore */
  }
  return DEFAULT_LOCALE;
};
